var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 6L15 12L9 18","stroke":"#1D3F91","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
